import app, { Component } from 'apprun';
import { isValid } from '../utils';

export default class UserPropertyComponent extends Component {
  state = { };

  view = (state) => {
    if (!state.item) {return;}
    let ph: string, dispInd: boolean;
    if (state.item.value.indexOf('(show)') > 0) {
      ph = state.item.value.replace('(show)', '').trim();
      dispInd = true;
    } else {
      ph = state.item.value.replace('(hide)', '').trim();
      dispInd = false;
    }
    return (
      <form id="phEditForm" class="form-horizontal" style={{ width: '450px' }}>
        <div class="row">
          <div class="col-sm-12">{state.item.dispName}</div>
          <div class="col-sm-12">
            <input id="inpPhNum" class="col-sm-10" value={ph} size="10" oninput={(e) => {ph = e.target.value;}} data-validate="Phone"/>
            &nbsp;
            Show<input id="inpFlag" type="checkbox" checked={dispInd ? 'checked' : null} onchange={(e) => {dispInd = e.target.checked;}}/>
          </div>
        </div>
        <div id="inpPhNumErrMsg" class="text-danger"></div>
        <div class="edit-buttons">
          <a
            type="button"
            class="btn btn-primary btn-xs"
            style={
              state.item.required || state.item.value === ''
                ? { display: 'none' }
                : { display: 'inline-block' }
            }
            onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
          </a>
          <a
            type="button"
            class="btn btn-primary btn-xs"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onclick={(e: any) => this.run('save', e, ph, dispInd)}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('cancel')}>
            cancel
          </a>
        </div>
      </form>
    );
  };

  update = {

    save: (state, e, ph, dispInd) => {
      state.newVal = ph + ' ' + (dispInd ?'(show)':'(hide)');
      if(!isValid('phEditForm')) { e.preventDefault(); return;}
      state.caller.run(state.save, state.item, state.panelId, state.newVal);
    },

    cancel: (state) => {
      state.caller.run(state.cancel, state.panelId);
    },
  }

  mounted = ({ state }) => state;
}
